"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import Api from "../../api/api";
import Auth from "../../util/auth";
export class CarrierInvoice {
  constructor(invoice, loadState) {
    __publicField(this, "invoice");
    __publicField(this, "loadState");
    this.invoice = invoice;
    this.loadState = loadState;
  }
  isApproved() {
    return this.invoice.state === "approved";
  }
  isPayableApproved() {
    return this.invoice.state === "approved" || this.invoice.state === "partial_approved";
  }
  unapprovalPermissions() {
    var _a;
    const settings = Api.Account.currentSettings() || {};
    const adminCanUnapprove = settings["can_unapprove_invoices"];
    const userCanUnapprove = adminCanUnapprove && !!((_a = Auth._currentUser) == null ? void 0 : _a.can_unapprove_invoices);
    return {
      userCanUnapprove,
      adminCanUnapprove,
      unapprovalsNotAllowed: !adminCanUnapprove
    };
  }
  unapprovingPayableAllowed() {
    const settings = Api.Account.currentSettings() || {};
    const blockedStatuses = settings["carrier_payable_block_unapprove_statuses"] || [];
    const payable = this.carrierPayable();
    return !(payable && blockedStatuses.includes(payable.status));
  }
  carrierPayable() {
    return this.invoice.tms_carrier_payable_id && this.loadState.load.load.tms_carrier_payables.find(
      (payable) => payable.id === this.invoice.tms_carrier_payable_id
    );
  }
}
